import { parseEnv } from '@moneytome/shared';

// Validate env at startup — a missing or invalid var fails fast and loud. Called for the
// throw rather than for a value: `main.tsx` imports this module for its side effect, and
// a binding nobody reads would exist only to keep an export alive.
parseEnv(import.meta.env);
